import React from 'react'

function LatestMatch() {
  return (
    <section className="latest-match-area latest-match-bg pt-115 pb-90">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three white-title text-center mb-70">
              <h2>Why Choose Our <span>Tech?</span></h2>
            </div>
          </div>
        </div>
        <div className="row">
          
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                 style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                src="assets/img/images/Mudgames - Gamification.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >Customisable <span>Gamification</span></h3>
                <p className="md-text-center" >
                  Highly customisable gamification templates like Treasure Chest, Spin The Wheel, and 50+ games.
                  Includes advanced game mechanics such as leaderboards & tournaments.
                </p>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img 
                 style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                src="assets/img/images/Mudgames - Integration.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >Low-code <span>Integration</span></h3>
                <p className="md-text-center" >
                  Plug-and-Play platform with smooth and quick integration across Website, Android, iOS, SDKs,
                  and API calls.
                </p>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img 
                 style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                src="assets/img/images/Mudgames - Campaign.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >Campaign <span>Rule</span></h3>
                <p className="md-text-center" >
                  Run contextual gamified campaigns with ready-to-use, rules-based templates that simplify campaign
                  creation and management.
                </p>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img 
                 style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                src="assets/img/images/Mudgames - Monitize.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >More Ways to <span>Monetize</span></h3>
                <p className="md-text-center" >
                  Reduce customer churn & increase lifetime value using gamified loyalty rewards programs and
                  innovative engagement strategies.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default LatestMatch
